/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOlInfoSharingConsent200Response
 */
export interface GetOlInfoSharingConsent200Response {
    /**
     * 
     * @type {string}
     * @memberof GetOlInfoSharingConsent200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOlInfoSharingConsent200Response
     */
    'status': GetOlInfoSharingConsent200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOlInfoSharingConsent200Response
     */
    'consentedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOlInfoSharingConsent200Response
     */
    'consentedAt': string | null;
}

export const GetOlInfoSharingConsent200ResponseStatusEnum = {
    notConsented: 'NOT_CONSENTED',
    consented: 'CONSENTED'
} as const;

export type GetOlInfoSharingConsent200ResponseStatusEnum = typeof GetOlInfoSharingConsent200ResponseStatusEnum[keyof typeof GetOlInfoSharingConsent200ResponseStatusEnum];


